// extracted by mini-css-extract-plugin
export default {"container":"GetCode_container__TqIC5","header":"GetCode_header__FsShA","content":"GetCode_content__5wim3"};